import React, { useState } from 'react';
import '../../Util/i18n';
import StepperBar from '../../Components/PitchCreation/StepperBar';
import ChooseStep from '../../Components/PitchCreation/ChooseStep';
import UploadStep from '../../Components/PitchCreation/UploadStep';
import ConvertingStep from '../../Components/PitchCreation/ConvertingStep';
import ReadyStep from '../../Components/PitchCreation/ReadyStep';
const STEP = {
    CHOOSE: 'CHOOSE',
    UPLOAD: 'UPLOAD',
    CONVERTING: 'CONVERTING',
    READY: 'READY'
};
const TOTAL_STEPS = 4;
const STEP_NUMBERS = {
    [STEP.CHOOSE]: 1,
    [STEP.UPLOAD]: 2,
    [STEP.CONVERTING]: 3,
    [STEP.READY]: 4
};
const PitchCreation = ({ createProposalUrl, uploadDeckUrl, convertUrl, statusUrl, logoUrl, maxFileSizeMb, acceptedExtensions }) => {
    const [step, setStep] = useState(STEP.CHOOSE);
    const [deckRef, setDeckRef] = useState(null);
    const [editUrl, setEditUrl] = useState(null);
    const startFromScratch = () => {
        // eslint-disable-next-line no-undef
        window.location.assign(createProposalUrl);
    };
    const goToUpload = () => {
        setStep(STEP.UPLOAD);
    };
    return (React.createElement("div", { className: "min-h-screen w-full bg-white" },
        React.createElement(StepperBar, { currentStep: STEP_NUMBERS[step], totalSteps: TOTAL_STEPS }),
        React.createElement("header", { className: "px-6 pt-6 md:px-10" },
            React.createElement("img", { src: logoUrl, alt: "Angel Investment Network", className: "h-12 w-auto" })),
        React.createElement("main", { className: "mx-auto w-full max-w-4xl px-4 pb-16 pt-10 md:pt-16" },
            step === STEP.CHOOSE && (React.createElement(ChooseStep, { onUpload: goToUpload, onScratch: startFromScratch })),
            step === STEP.UPLOAD && (React.createElement(UploadStep, { uploadDeckUrl: uploadDeckUrl, maxFileSizeMb: maxFileSizeMb, acceptedExtensions: acceptedExtensions, onCancel: () => {
                    return setStep(STEP.CHOOSE);
                }, onContinue: (ref) => {
                    setDeckRef(ref);
                    setStep(STEP.CONVERTING);
                } })),
            step === STEP.CONVERTING && deckRef && (React.createElement(ConvertingStep, { convertUrl: convertUrl, statusUrl: statusUrl, deckRef: deckRef, onDone: (url) => {
                    setEditUrl(url);
                    setStep(STEP.READY);
                }, onSkip: startFromScratch, onChangeFile: () => {
                    setDeckRef(null);
                    setStep(STEP.UPLOAD);
                } })),
            step === STEP.READY && editUrl && React.createElement(ReadyStep, { editUrl: editUrl }))));
};
export default PitchCreation;
